<template>
    <Layout>
        <template v-slot:title>
            <h1>
                {{
                    isBuyCreditOrder
                        ? 'Buy Credit'
                        : isPayPlayerOrder
                        ? 'Buy Player'
                        : isBuyAiQuestionOrder
                        ? 'Buy AI Questions'
                        : 'Subscription'
                }}
                Orders
            </h1>
        </template>

        <template v-slot:content>
            <Loader v-if="isLoading" />

            <div class="row mb-4">
                <div class="col-sm-6 col-md-4 col-xl-3 mb-2 mb-md-0">
                    <form @submit.prevent="onSearch" class="input-group btn-inline">
                        <input
                            v-model="keyword"
                            name="table_search"
                            class="form-control float-right"
                            placeholder="Search order ID"
                            type="text"
                        />

                        <div class="input-group-append">
                            <button type="submit" class="btn btn-default">
                                <f-icon icon="search" />
                            </button>
                        </div>
                    </form>
                </div>
                <div class="col-sm-6 col-md-4 col-xl-3 mb-4 mb-md-0">
                    <select class="form-control" v-model="mothodType" @change="filterByMethod">
                        <option value="">Filter by method</option>
                        <option v-for="method in paymentMethods" :value="method.value" :key="method.value">
                            {{ method.label }}
                        </option>
                    </select>
                </div>
                <div v-if="!isBuyCreditOrder && !isBuyAiQuestionOrder" class="col-sm-6 col-md-4 col-xl-2 mb-2 mb-md-0">
                    <div class="h-100 d-flex align-items-center" @click="filterExpired">
                        <CheckSquareIcon
                            v-if="onlyActive"
                            size="1.5x"
                            class="cursor-pointer text-success"
                        ></CheckSquareIcon>
                        <SquareIcon v-else size="1.5x" class="cursor-pointer"></SquareIcon>
                        <label class="m-0 ml-2 cursor-pointer font-weight-light">Show only active</label>
                    </div>
                </div>

                <div
                    v-if="!isPayPlayerOrder && !isBuyCreditOrder && !isBuyAiQuestionOrder"
                    class="col-sm-6 col-md-4 col-xl-4 mb-4 mb-md-0 d-flex justify-content-end"
                >
                    <router-link tag="a" :to="{ name: 'orders.orderPending' }" class="nav-link btn btn-secondary">
                        <i class="fas fa-list mr-2"></i>
                        Show pending
                    </router-link>
                </div>
            </div>

            <div v-if="orders.length" class="row">
                <div class="col-lg-12">
                    <div class="table-responsive tbq-table-responsive">
                        <table class="table tbq-table">
                            <thead>
                                <tr>
                                    <th>Order ID</th>
                                    <th>Gateway</th>
                                    <th>Payer</th>
                                    <th>Amount</th>
                                    <th v-if="isPayPlayerOrder && !isBuyAiQuestionOrder">Quiz</th>
                                    <th v-if="isPayPlayerOrder && !isBuyAiQuestionOrder">Expire Date</th>
                                    <th style="width: 10%" v-if="!isBuyCreditOrder && !isBuyAiQuestionOrder"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="order in orders" :key="order._id.$oid">
                                    <td>
                                        <p class="mb-0 text-bold">{{ setNameOrder(order) }}</p>
                                        <p class="mb-0">{{ order.order_id }}</p>
                                        <div v-if="getCampaign(order.campaign)">
                                            <small style="color: #c82333; font-weight: 700">Coupon campaign: </small>
                                            <small style="color: #c82333">{{ getDataCampaign(order.campaign) }}</small>
                                        </div>
                                        <small>Created At {{ order.created_at }}</small>
                                    </td>
                                    <td>
                                        <p
                                            :class="{
                                                'mb-0 ucfirst': true,
                                                'text-paypal': order.method == 'paypal',
                                                'text-stripe': order.method == 'stripe-checkout',
                                                'text-vipps': order.method == 'vipps'
                                            }"
                                        >
                                            {{ order.method.replace(/-checkout/gi, '') }}
                                        </p>
                                    </td>
                                    <td>
                                        <a
                                            v-if="order.user.name"
                                            @click.prevent="filterByUser(order.user._id.$oid)"
                                            href="javascript:void(0)"
                                            class="cursor-pointer"
                                        >
                                            {{ order.user.name }}
                                        </a>
                                        <UserIcon
                                            v-if="order.user.name"
                                            @click.prevent="setUserSelected(order.user)"
                                            style="border: 1px solid #28a745; border-radius: 50px;"
                                            size="1x"
                                            class="cursor-pointer text-green" />
                                        <i v-if="!order.user.name">[This user unregistered]</i>
                                    </td>
                                    <td>
                                        <div class="d-block">
                                            <p class="mb-0">
                                                <span v-if="order.currency && order.currency === 'NOK'">
                                                    {{ moneyNokFormat(order.amount) }}
                                                </span>
                                                <span v-else>
                                                    {{ moneyUsdFormat(order.amount) }}
                                                </span>
                                            </p>
                                            <small v-if="isBuyCreditOrder">{{ order.credits }} credit(s)</small>
                                            <small v-else-if="isBuyAiQuestionOrder"
                                                >{{ order.data.limit_player || order.data.limit }} questions</small
                                            >
                                            <small v-else>{{ order.data.limit_player }} player(s)</small>
                                        </div>
                                    </td>
                                    <td v-if="isPayPlayerOrder">
                                        <span v-if="order.quiz">
                                            <a
                                                @click.prevent="filterByQuiz(order.quiz._id.$oid)"
                                                href="javascript:void(0)"
                                                class="cursor-pointer"
                                            >
                                                {{ order.quiz.title }}
                                            </a>
                                        </span>
                                        <span v-if="order.quiz_id == 'edit_question'">[From Edit Question]</span>
                                    </td>
                                    <td v-if="isPayPlayerOrder">
                                        <DiscIcon
                                            :class="{ 'text-gray': !order.is_active, 'text-green': order.is_active }"
                                            size="1x"
                                        />
                                        {{ order.expires_at }}
                                    </td>
                                    <td v-if="!isBuyCreditOrder && !isBuyAiQuestionOrder">
                                        <div v-if="isPayPlayerOrder && order.type === 'buy-player'">
                                            <button
                                                v-if="order.buy_player_status != 'suspend'"
                                                @click.stop="suspendBuyOrder(order.order_id)"
                                                class="btn btn-danger text-center p-2 btn-sm"
                                            >
                                                Suspend
                                            </button>
                                            <div v-else class="text-red text-center p-2">Suspended</div>
                                        </div>

                                        <div v-if="!isPayPlayerOrder">
                                            <div
                                                v-if="order.subscription_status == 'active' && order.user"
                                                class="d-flex justify-content-center"
                                            >
                                                <button
                                                    v-if="order.order_id"
                                                    @click.stop="unsubscribe(order.order_id)"
                                                    class="btn btn-sm btn-warning mr-2"
                                                >
                                                    Unsubscribe
                                                </button>
                                                <button
                                                    @click.stop="suspend(order.order_id, order._id.$oid)"
                                                    class="btn btn-sm btn-danger"
                                                >
                                                    Suspend
                                                </button>
                                            </div>
                                            <div
                                                v-else-if="order.subscription_status == 'unsubscribe'"
                                                class="text-center"
                                            >
                                                <small class="text-gray d-block mt-2" v-if="order['expires_at']">
                                                    Expire Date: {{ order['expires_at'].split(' ').shift() }}
                                                </small>
                                            </div>
                                            <div v-else disabled class="text-red text-center p-2">Suspend</div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div v-if="orders.length" class="col-12 my-3">
                <Paginator
                    @change="onPageChange"
                    :current-page="currentPage"
                    :page-count="pageCount"
                    :total-items="totalItems"
                />
            </div>
            <EmptyList v-if="isEmpty" :label="emptyLabel" />

            <FormModal :user="selectUser" id="modal-user" />
        </template>
    </Layout>
</template>

<script>
import jQuery from 'jquery'
import API_URL from '@/router/api'
import Layout from '@/components/Layout'
import { DiscIcon, CheckSquareIcon, SquareIcon, UserIcon } from 'vue-feather-icons'
import Paginator from '@/components/Paginator'
import Loader from '@/components/Loader'
import EmptyList from '@/components/EmptyList'
import FormModal from '@/components/user/FormModal'
import axios from 'axios'
import Url from '@/service/url'
import appConfig from '@/app.config'
import orderMixin from '@/mixins/order'

export default {
    mixins: [orderMixin],

    components: {
        Layout,
        Paginator,
        Loader,
        EmptyList,
        DiscIcon,
        CheckSquareIcon,
        SquareIcon,
        UserIcon,
        FormModal
    },

    data() {
        return {
            orders: [],
            paymentMethods: appConfig.payment_method,
            isLoading: false,
            isEmpty: false,
            onlyActive: false,
            currentPage: 1,
            pageCount: 0,
            totalItems: 0,
            keyword: '',
            mothodType: '',
            emptyLabel: 'No order found.',
            selectUser: null,
        }
    },

    watch: {
        $route() {
            this.setParams()
        }
    },

    mounted() {
        this.setParams()
    },

    computed: {
        isPayPlayerOrder() {
            return this.$route.params.type == 'buy-player'
        },

        isBuyCreditOrder() {
            return this.$route.params.type == 'buy-credit'
        },

        isBuyAiQuestionOrder() {
            return this.$route.params.type == 'buy-ai-questions'
        },

        isSubscriptionOrder() {
            return this.$route.params.type == 'subscription'
        }
    },

    methods: {
        setUserSelected(user) {
            const userSelect = Object.assign({}, user, { loading: true })

            this.$store
                .dispatch('user/findUserDetail', user['_id']['$oid'])
                .then(res => {
                    const orders = res.data.data.user_detail.orders
                    let totalOrderValue = 0

                    for (let index in orders) {
                        totalOrderValue = totalOrderValue + parseFloat(orders[index]['amount'])
                    }

                    this.selectUser = Object.assign(
                        {},
                        userSelect,
                        { total_order_value: totalOrderValue },
                        { user_detail: res.data.data.user_detail },
                        { loading: false }
                    )

                    jQuery('#modal-user').modal('show')
                })
                .catch(err => {
                    if (err) {
                        this.selectUser = Object.assign({}, userSelect, { loading: false })
                    }
                })
        },

        setParams() {
            const url = new Url()
            const query = url.getQuery()

            this.fetchOrder(query)

            this.paymentMethods = this.paymentMethods.filter(i =>
                this.$route.params.type == 'buy-player' ? i : i.value != 'credit'
            )
            this.onlyActive = typeof query.onlyActive != 'boolean' ? query.onlyActive == 'true' : query.onlyActive
            this.mothodType = query.method || ''
            this.keyword = query.keyword || ''
        },

        fetchOrder(query) {
            this.isLoading = true
            this.isEmpty = false
            this.orders = []

            axios
                .get(API_URL.order.list, {
                    params: Object.assign(query, { type: this.$route.params.type })
                })
                .then(res => {
                    this.isLoading = false
                    this.orders = res.data.data.data

                    if (!this.orders.length) {
                        this.isEmpty = true
                    }

                    this.pageCount = res.data.data.page_count
                    this.totalItems = res.data.data.total
                    this.currentPage = parseInt(res.data.data.current_page)
                })
                .catch(() => {
                    this.isLoading = false
                })
        },

        filterByUser(userId) {
            const url = new Url()
            const query = url.getQuery()

            if (query.user_id == userId) {
                return
            }

            this.$router.push({
                name: 'user.order-list',
                params: {
                    id: userId
                },
            })
        },

        filterByQuiz(quizId) {
            const url = new Url()
            const query = url.getQuery()

            if (query.quiz_id == quizId) {
                return
            }

            this.$router.push({
                name: 'orders.index',
                params: this.$route.params,
                query: {
                    quiz_id: quizId
                }
            })
        },

        filterByMethod(event) {
            const url = new Url()
            const query = url.getQuery()

            if (query.method == event.target.value) {
                return
            }

            this.$router.push({
                name: 'orders.index',
                params: this.$route.params,
                query: {
                    ...query,
                    ...{ method: event.target.value }
                }
            })
        },

        filterExpired() {
            const url = new Url()
            const query = url.getQuery()

            this.$router.push({
                name: 'orders.index',
                params: this.$route.params,
                query: {
                    ...query,
                    ...{ onlyActive: !this.onlyActive }
                }
            })
        },

        onPageChange(page) {
            const url = new Url()
            const query = url.getQuery()

            if (query.page == page) {
                return
            }

            this.$router.push({
                name: 'orders.index',
                params: this.$route.params,
                query: Object.assign(query, {
                    page
                })
            })
        },

        onSearch() {
            const url = new Url()
            const query = url.getQuery()

            if (query.keyword == this.keyword) {
                return
            }

            this.$router.push({
                name: 'orders.index',
                params: this.$route.params,
                query: {
                    ...query,
                    ...{ keyword: this.keyword }
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../scss/order.scss';
</style>
